import { Route } from 'react-router';

export function getGlobalResourceRoutes(enabled: boolean) {
  if (enabled) {
    return (
      <>
        <Route id="resources-teams" path="resources/teams" lazy={() => import('routes/resources/teams/teams.route')} />
        <Route
          id="resources-current-user"
          path="resources/current-user"
          lazy={() => import('routes/resources/current-user/current-user.route')}
        />
        <Route
          id="resources-current-user-permissions"
          path="resources/current-user-permissions"
          lazy={() => import('routes/resources/current-user/current-user-permissions.route')}
        />
        <Route
          id="resources-clinical-locations"
          path="resources/clinical-locations"
          lazy={() => import('routes/resources/clinical-locations')}
        />
        <Route
          id="resources-clinical-location-groups"
          path="resources/clinical-location-groups"
          lazy={() => import('routes/resources/clinical-location-groups')}
        />
        <Route
          id="resources-requesting-locations"
          path="resources/requesting-locations"
          lazy={() => import('routes/resources/requesting-locations')}
        />
        <Route
          id="resources-vendor-status-disruption-types"
          path="resources/vendor-status-disruption-types"
          lazy={() => import('routes/resources/vendor-status-disruption-types')}
        />
        <Route
          id="resources-manufacturers"
          path="resources/manufacturers"
          lazy={() => import('routes/resources/manufacturers')}
        />
        <Route
          id="resources-inventory-locations"
          path="resources/inventory-locations"
          lazy={() => import('routes/resources/inventory-locations')}
        />
        <Route id="resources-vendors" path="resources/vendors" lazy={() => import('routes/resources/vendors')} />
        <Route
          id="resources-departments"
          path="resources/departments"
          lazy={() => import('routes/resources/departments')}
        />
        <Route id="resources-unspsc" path="resources/unspsc" lazy={() => import('routes/resources/unspsc')} />
        <Route
          id="resources-categorization-labels"
          path="resources/categorization-labels"
          lazy={() => import('routes/resources/categorization-labels')}
        />
      </>
    );
  }

  return null;
}
